<div class="flex flex-col pt-4 space-y-4">
  <app-section-header
    [title]="pageHeader"
    [isBackBtnShown]="true"
    [backRoute]="['/dashboard']"
  >
    <app-content-state-controls
      *ngIf="initialGalleryContent"
      [allowableNextStates]="
        initialGalleryContent.dynamicData.allowableNextStates
      "
      [isProcessingStateChange]="isProcessingStateChange"
      [isPublished]="initialGalleryContent.isPublished()"
      [isSpiked]="initialGalleryContent.isSpiked"
      [form]="form"
      [isSaving]="isSaving"
      (handleStateChange)="onUpdateState($event)"
      (handleReEditClick)="onCreateNewVersion()"
      (handleReactivateClick)="onReactivateGallery()"
    ></app-content-state-controls>
  </app-section-header>
  <ng-container *ngIf="isProcessing || initialGalleryContent">
    <app-processing-boundary
      [isProcessing]="isProcessing || !initialGalleryContent"
      [processingMsg]="'Loading...'"
    >
      <ng-container *ngIf="!isProcessing && initialGalleryContent">
        <div *ngIf="initialGalleryContent">
          <app-content-status-card
            [form]="form"
            [formReady]="formReady.asObservable()"
            [content]="initialGalleryContent"
            [isSaving]="isSaving"
            (handleSave)="onSave()"
            class="px-4"
          ></app-content-status-card>
          <app-content-status-message
            [content]="initialGalleryContent"
            [contentType]="CONTENT_TYPES.GALLERY"
          ></app-content-status-message>
        </div>
        <form
          class="flex p-4 space-x-4"
          (keydown.enter)="$event.preventDefault()"
          [formGroup]="form"
          *ngIf="initialGalleryContent"
        >
          <div class="flex flex-col flex-1 min-w-0 space-y-4">
            <app-headline-input
              [control]="form.get(FORM_PATHS.HEADLINE())"
            ></app-headline-input>
            <app-standfirst-text
              [control]="form.get(FORM_PATHS.STANDFIRST())"
            ></app-standfirst-text>
            <app-media-adder
              [sectionImgsFormControl]="form.get(FORM_PATHS.MAIN_IMAGE())"
              [displayImageOnWebsiteControl]="
                form.get(FORM_PATHS.DISPLAY_IMAGE_ON_WEBSITE())
              "
              [isMainMedia]="true"
              [mainMediaLabel]="'Main Image'"
              [addMediaLabel]="'Add main'"
              [isDisabled]="!isEditMode"
              [showCaption]="false"
            >
            </app-media-adder>
            <app-slide-list
              [slideArray]="form.get(FORM_PATHS.SLIDES())"
              [isDisabled]="!isEditMode"
            >
            </app-slide-list>
          </div>
          <div class="flex flex-1 min-w-0 pt-1.5 mt-2">
            <mat-accordion [multi]="false" class="flex flex-1 space-x-3">
              <div class="flex flex-col w-1/2 min-w-0 space-y-3 basis-1/2">
                <app-expandable-checkbox-list
                  [iconClass]="'icon-globe'"
                  [title]="'Websites'"
                  [formGroup]="form.get(FORM_PATHS.WEBSITES())"
                  [metadata]="deliveryTargets$ | async"
                  [isExpandedByDefault]="isNewGallery"
                  [isExpandable]="isEditMode"
                  (onItemChecked)="onEditionAdded($event)"
                  (onItemUnchecked)="onEditionRemoved($event)"
                  id="formFieldWebsites"
                ></app-expandable-checkbox-list>
                <app-content-list
                  [contentListControl]="form.get(FORM_PATHS.CONTENT_LISTS())"
                  [websites]="_buildDeliveryTargetCodes()"
                  [isExpandedByDefault]="false"
                  [isExpandable]="isEditMode"
                ></app-content-list>
                <app-surtitles
                  [surtitleControl]="form.get(FORM_PATHS.SURTITLES())"
                  [tagControl]="form.get(FORM_PATHS.TAGS())"
                  [typedTags]="form.get(FORM_PATHS.TYPED_TAGS())"
                  [isExpandedByDefault]="false"
                  [isExpandable]="isEditMode"
                  [currentEditionLanguage]="
                    form.get(FORM_PATHS.EDITION_LANGUAGE())
                  "
                  [detailedTopicList]="
                    form.get(FORM_PATHS.TOPICS_WITH_TRANSLATIONS())
                  "
                  (handleAddToBody)="onAddToBody($event)"
                  (handleRemoveLink)="onRemoveLink($event)"
                >
                </app-surtitles>
                <app-related-data
                  [isExpandable]="isEditMode"
                  [isExpandedByDefault]="false"
                  [isShowingSurtitles]="true"
                  [managerListControl]="form.get(FORM_PATHS.RELATED_MANAGERS())"
                  [fundListControl]="form.get(FORM_PATHS.RELATED_FUNDS())"
                  [sectorListControl]="form.get(FORM_PATHS.RELATED_SECTORS())"
                  [assetClassListControl]="
                    form.get(FORM_PATHS.RELATED_ASSET_CLASSES())
                  "
                  [investmentTrustListControl]="
                    form.get(FORM_PATHS.RELATED_INVESTMENT_TRUSTS())
                  "
                  [shareListControl]="form.get(FORM_PATHS.RELATED_SHARES())"
                  (handleAddToBody)="onAddToBody($event)"
                  (handleRemoveLink)="onRemoveLink($event)"
                  (handleItemSelected)="onTagItemSelected($event)"
                  (handleItemRemoved)="onTagItemRemoved($event)"
                  (handleSurtitlePromoted)="onSurtitlePromoted($event)"
                ></app-related-data>
                <app-related-articles
                  [isExpandedByDefault]="false"
                  [isExpandable]="isEditMode"
                  [relatedContents]="form.get(FORM_PATHS.RELATED_ARTICLES())"
                  [editions]="_buildDeliveryTargetCodes()"
                  (handleAddToBody)="onAddToBody($event)"
                  (handleRemoveLink)="onRemoveLink($event)"
                ></app-related-articles>

                <app-tagging
                  [topicControl]="form.get(FORM_PATHS.TOPICS())"
                  [tagControl]="form.get(FORM_PATHS.TAGS())"
                  [companyControl]="form.get(FORM_PATHS.COMPANIES())"
                  [peopleControl]="form.get(FORM_PATHS.PEOPLE())"
                  [websites]="_buildDeliveryTargetCodes()"
                  [isExpandedByDefault]="false"
                  [isExpandable]="isEditMode"
                  [isShowingSurtitles]="true"
                  (handleAddToBody)="onAddToBody($event)"
                  (handleRemoveLink)="onRemoveLink($event)"
                  (handleItemSelected)="onTagItemSelected($event)"
                  (handleItemRemoved)="onTagItemRemoved($event)"
                  (handleSurtitlePromoted)="onSurtitlePromoted($event)"
                >
                </app-tagging>
                <app-external-links
                  [isExpandable]="isEditMode"
                  [isExpandedByDefault]="false"
                  [externalLinksControl]="form.get(FORM_PATHS.EXTERNAL_LINKS())"
                  (handleAddToBody)="onAddToBody($event)"
                  (handleRemoveLink)="onRemoveLink($event)"
                ></app-external-links>
              </div>
              <div class="flex flex-col w-1/2 min-w-0 space-y-3 basis-1/2">
                <app-publish-time
                  [publishTimeControl]="form.get(FORM_PATHS.PUBLISH_TIME())"
                  [timezoneControl]="form.get(FORM_PATHS.TIMEZONE())"
                  [showPublishTimeControl]="
                    form.get(FORM_PATHS.SHOW_PUBLISH_TIME())
                  "
                  [isExpandedByDefault]="false"
                  [isExpandable]="isEditMode"
                  [timezones]="timezones"
                ></app-publish-time>
                <app-authors
                  id="formSectionAuthors"
                  data-testid="formSectionAuthors"
                  [isExpandedByDefault]="false"
                  [isExpandable]="isEditMode"
                  [selectedAuthors]="form.get(FORM_PATHS.SELECTED_AUTHORS())"
                  [searchedAuthor]="searchedAuthor"
                  [authorList]="authorList"
                  [searchList]="searchList"
                ></app-authors>
                <app-columnist-content
                  [isExpandedByDefault]="false"
                  [isExpandable]="isEditMode"
                  [isColumnistContent]="
                    form.get(FORM_PATHS.COLUMNIST_CONTENT())
                  "
                ></app-columnist-content>
                <app-visibility
                  id="formSectionVisibility"
                  data-testid="formSectionVisibility"
                  [isExpandedByDefault]="false"
                  [isExpandable]="isEditMode"
                  [restrictToRegisteredUsersControl]="
                    form.get(FORM_PATHS.RESTRICTED_TO_REGISTERED_USERS())
                  "
                  [notForGoogleNewsSitemapsControl]="
                    form.get(FORM_PATHS.NOT_FOR_GOOGLE_NEWS_SITEMAPS())
                  "
                  [notForNewsFeedsControl]="
                    form.get(FORM_PATHS.NOT_FOR_NEWS_FEED())
                  "
                  [hideThisArticleControl]="
                    form.get(FORM_PATHS.HIDE_THIS_ARTICLE())
                  "
                  [paywallPremiumContent]="
                    form.get(FORM_PATHS.PAYWALL_PREMIUM_CONTENT())
                  "
                  [notForCompetitors]="
                    form.get(FORM_PATHS.NOT_FOR_COMPETITORS())
                  "
                ></app-visibility>
                <app-expandable-dropdown
                  id="formFieldBodyLanguage"
                  [iconClass]="'icon-language'"
                  [title]="'Language'"
                  [sectionFormControl]="form.get(FORM_PATHS.LANGUAGE())"
                  [labelKey]="'FriendlyName'"
                  [options]="languages$ | async"
                  [defaultOption]="DEFAULT_LANGUAGE_OPTION"
                  [isExpandedByDefault]="false"
                  [isExpandable]="isEditMode"
                ></app-expandable-dropdown>
                <app-internal-information
                  [urls]="initialGalleryContent.dynamicData.liveUrls"
                  [contentId]="initialGalleryContent.contentId"
                  [isExpandedByDefault]="false"
                ></app-internal-information>
                <app-version-list
                  [versions]="initialGalleryContent.dynamicData.versions"
                  [articleId]="initialGalleryContent.id"
                  [latestPublishedVersionId]="
                    initialGalleryContent.dynamicData.latestPublishedVersionId
                  "
                  [latestVersionId]="
                    initialGalleryContent.dynamicData.latestVersionId
                  "
                  [isExpandedByDefault]="false"
                  [contentType]="CONTENT_TYPES.GALLERY"
                ></app-version-list>
                <app-repurposed-content
                  [repurposedTo]="initialGalleryContent.repurposedArticles"
                  [repurposedFrom]="
                    initialGalleryContent.repurposedFromArticles
                  "
                  [contentType]="CONTENT_TYPES.GALLERY"
                >
                </app-repurposed-content>
                <button
                  mat-button
                  type="button"
                  class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                  *ngIf="!isNewGallery && canRepurpose$ | async"
                  (click)="repurposeGallery()"
                  [disabled]="isProcessingStateChange || isSaving"
                  mat-raised-button
                  data-testid="repurposeButton"
                >
                  Repurpose
                </button>
                <button
                  mat-button
                  type="button"
                  class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                  *ngIf="
                    initialGalleryContent.isPublished() &&
                    !initialGalleryContent.isSpiked &&
                    initialGalleryContent.dynamicData
                      .latestPublishedVersionId === initialGalleryContent.id
                  "
                  (click)="spikeGallery()"
                  mat-raised-button
                  data-testid="spikeButton"
                >
                  Spike
                </button>
                <button
                  mat-button
                  type="button"
                  class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                  *ngIf="
                    !initialGalleryContent.isPublished() &&
                    initialGalleryContent.dynamicData.versions.length > 1
                  "
                  (click)="deleteUnpublishedDraft()"
                  [disabled]="isProcessingStateChange || isSaving"
                  mat-raised-button
                  data-testid="deleteUnpublishedButton"
                >
                  Delete Unpublished Draft
                </button>
                <button
                  mat-button
                  type="button"
                  class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                  *ngIf="!isNewGallery"
                  (click)="deleteGallery()"
                  [disabled]="isProcessingStateChange || isSaving"
                  mat-raised-button
                  data-testid="deleteButton"
                >
                  Delete Content
                </button>
              </div>
            </mat-accordion>
          </div>
        </form>
      </ng-container>
    </app-processing-boundary>
  </ng-container>
</div>
